import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigTituloPaginasService } from '@appNeo/core/services/config-titulo-paginas.service';
import { HelpersService } from '@appNeo/neoCore/services/helpers/helpers.service';
import { EdicionSeccionesService } from '@appNeo/neoShared/modules/edicion-secciones/edicion-secciones.service';
import {FAQS} from '@appNeo/pages/pages/pagina-faqs/faqs-configuracion';
import { environment } from '@environments/environment';

@Component({
  selector: 'neo-pagina-faqs',
  templateUrl: './pagina-faqs.component.html',
  styleUrls: ['./pagina-faqs.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class PaginaFaqsComponent implements OnInit {
  faqs = FAQS;
  titulo = 'TXT-TIT'
  // secciones editables
  secciones: [] = [];  
  precargaMeta;
  faqInicialActivo = -1;
  constructor(private helpersService: HelpersService,
    private configTitulo: ConfigTituloPaginasService,
    private route: ActivatedRoute,
    private edicionSeccionesService: EdicionSeccionesService) {
    this.route.data.subscribe(
      response => {
        console.log('Data precargada', response);
        this.precargaMeta = response.seccionesEditables.precargaMeta;
      }
    );
  }

  ngOnInit(): void {
    this.faqInicialActivo = (this.route.snapshot.queryParamMap.get('faq')) ? Number(this.route.snapshot.queryParamMap.get('faq')) : -1;
    this.iniciarPagina();
  }

  iniciarPagina() {
    // **********************************
    // Titulo y meta
    // **********************************
    this.configTitulo.establecerTitulo('Preguntas frecuentes', 'faq-meta', this.precargaMeta, 'meta-tit');
    this.configTitulo.establecerMeta(environment.descripcionMetaDefecto, 'faq-meta', this.precargaMeta, 'meta-des');
    // **********************************
    // CONTENIDO FAQS
    // **********************************
    let contenidoSeccion = [];
    let datosSubgrupo = [];
    if (this.helpersService.hayModulo('edicion')) {

      // texto principal
      this.edicionSeccionesService.getContenidoBloquesSubseccion('faq-txt').subscribe(data => {
        data.elementos.forEach((elemento, index) => {
          let indice = (data.multiple) ? index : -1;
          this.titulo = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'txt-tit', indice);
          return;
        })

      })

      // listado faqs
      this.edicionSeccionesService.getContenidoBloquesSubseccion('faq-faq').subscribe(data => {

        data.elementos.forEach((elemento, index) => {
          let datosColapsar = new Object();
          datosColapsar['tituloTexto'] = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'faq-tit', index);
          datosColapsar['contenido'] = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'faq-txt', index);
          datosColapsar['grupo'] = 'faq';
          datosColapsar['opened'] = false;
          datosColapsar['linkHref'] = null;
          datosColapsar['titleTag'] = 'h2',
            datosColapsar['iconOpened'] = 'icon-ibm-subtract',
            datosColapsar['iconClosed'] = 'icon-ibm-add';
          contenidoSeccion[index] = datosColapsar;
          // echo $this->load->view(RUTA_THEME.'plugins/collapse', $dataCollapse, true);
        })

      })
    } else {
      for (let i = 1; i <= 4; i++) {
        let datosColapsar = [];
        datosColapsar['tituloTexto'] = 'hero-tit' + i;
        datosColapsar['contenido'] = 'hero-txt' + i;
        datosColapsar['grupo'] = 'faq';
        datosColapsar['opened'] = false;
        datosColapsar['linkHref'] = null;
        datosColapsar['titleTag'] = 'h2',
          datosColapsar['iconOpened'] = 'icon-ibm-subtract',
          datosColapsar['iconClosed'] = 'icon-ibm-add';
        contenidoSeccion.push(datosColapsar);
        // echo $this->load->view(RUTA_THEME.'plugins/collapse', $dataCollapse, true);
      }
    }
    datosSubgrupo['id'] = 'hero-slider';
    datosSubgrupo['elementos'] = contenidoSeccion;
    datosSubgrupo['handlers'] = true;
    datosSubgrupo['pagination'] = 'fraction';
    this.secciones['faq'] = [];
    this.secciones['faq']['faq-faq'] = datosSubgrupo;

  }
}
